import React from 'react';
import { Badge } from 'react-bootstrap';
import './AboutMe.css'

const AboutMe = () => {
    return (
        <div>
            <h2 className='text-center mb-5 mt-5' id='about'>About Me</h2>
            <div className="row">
                <div className="col-md-6 skills">
                    <h2 className='text-center orelega-font'>Skills</h2>

                    <div className="ml-5 mb-5">
                        <h4 className='mb-3 orelega-font'>Comfortable</h4>
                        <Badge variant="info m-2">Javascript</Badge>
                        <Badge variant="info m-2">ES6</Badge>
                        <Badge variant="info m-2">React.js</Badge>
                        <Badge variant="info m-2">React Router</Badge>
                        <Badge variant="info m-2">Bootstrap</Badge>
                        <Badge variant="info m-2">Node.js</Badge>
                        <Badge variant="info m-2">Express.js</Badge>
                        <Badge variant="info m-2">MongoDB</Badge>
                        <Badge variant="info m-2">HTML5</Badge>
                        <Badge variant="info m-2">CSS3</Badge>
                        <Badge variant="info m-2">C</Badge>
                        <Badge variant="info  m-2">C++</Badge>

                        <h4 className='mt-5 mb-3 orelega-font'>Familiar</h4>
                        <Badge variant="info  m-2">Typescript</Badge>
                        <Badge variant="info  m-2">Sass</Badge>
                        <Badge variant="info  m-2">Redux</Badge>
                        <Badge variant="info  m-2">React Native</Badge>
                        <Badge variant="info  m-2">Python</Badge>

                        <h4 className='mt-5 mb-3 orelega-font'>Tools</h4>
                        <Badge variant="info  m-2">Git</Badge>
                        <Badge variant="info  m-2">Linux</Badge>
                        <Badge variant="info  m-2">VS Code</Badge>
                        <Badge variant="info  m-2">Chrome Deb Tool</Badge>
                        <Badge variant="info  m-2">Heroku</Badge>
                        <Badge variant="info  m-2">Netlify</Badge>
                        <Badge variant="info  m-2"> Firebase</Badge>

                    </div>

                </div>

                <div className="col-md-6">
                    <h2 className='text-center orelega-font'>Education</h2>
                    <div className="ml-5 mb-5">
                        <h4 className='mb-3 orelega-font'>Under Graduation</h4>
                        <h5 className='ml-4'>Leading University</h5>
                        <h6 className='ml-4' >B.Sc. (Honours) in Computer Science & Engineering <br />
                        January 2019 - Present <br />
                        CGPA: 3.85 (till 7th Semester)</h6>

                        <h4 className=' mt-5 mb-3 orelega-font'>Higher Secondary</h4>
                        <h5 className='ml-4'>Taibunessa Khanam Academy College</h5>
                        <h6 className='ml-4' >HSC <br />
                        GPA: 4.25</h6>

                        <h4 className=' mt-5 mb-3 orelega-font'>Secondary</h4>
                        <h5 className='ml-4'>Jaifornagar High School</h5>
                        <h6 className='ml-4' >SSC <br />
                        GPA: 5.00 </h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;